import { render } from "./WpMaintenance.vue?vue&type=template&id=7a6463e8"
import script from "./WpMaintenance.vue?vue&type=script&lang=js"
export * from "./WpMaintenance.vue?vue&type=script&lang=js"

import "./WpMaintenance.vue?vue&type=style&index=0&id=7a6463e8&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__